module.exports = __webpack_public_path__ + "staticesp/media/gif-dimen-es.3965d7b9.gif";